<template>
    <div class="pb-2">
        <Button aria-label="Share on Facebook" class="p-button-rounded facebook-btn mr-2" icon="pi pi-facebook" @click="share('facebook')"/>
        <Button aria-label="Share on Twitter" class="p-button-rounded twitter-btn mr-2" icon="pi pi-twitter" @click="share('twitter')"/>
        <Button aria-label="Share on LinkedIn" class="p-button-rounded linkedin-btn mr-2" icon="pi pi-linkedin" @click="share('linkedin')"/>
        <Button aria-label="Share on Viber" class="p-button-rounded mr-2 viber-btn" icon="pi pi-share-alt" @click="share('viber')"/>
    </div>
</template>

<script>
import Button from 'primevue/button';

export default {
    components : {
        Button
    },
    methods    : {
        share(platform) {
            const url = encodeURIComponent(window.location.href);
            switch (platform) {
                case 'facebook':
                    window.open(`https://www.facebook.com/sharer.php?u=${url}`, '_blank');
                    break;
                case 'twitter':
                    window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank');
                    break;
                case 'linkedin':
                    window.open(`https://www.linkedin.com/shareArticle?url=${url}`, '_blank');
                    break;
                case 'instagram':
                    alert('Instagram does not officially support sharing from the web.');
                    break;
                case 'viber':
                    window.open(`viber://forward?text=${url}`, '_blank');
                    break;
            }
        },
    },
}
</script>

<style scoped>
.facebook-btn {
    background-color : #3b5998; /* Facebook color */
    border-color     : #3b5998;
}

.twitter-btn {
    background-color : #1da1f2; /* Twitter color */
    border-color     : #1da1f2;
}

.linkedin-btn {
    background-color : #0077b5; /* LinkedIn color */
    border-color     : #0077b5;
}

.viber-btn {
    background-color : #665cac; /* Viber color */
    border-color     : #665cac;
}
</style>